import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProfile } from 'utils/helpers';
import { toastSuccess } from 'ui/partials/Toast';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

function useLoginNominateVerifyOtp() {
  const { setProfile } = useProfile();
  const { state } = useProvider();
  const args = state;

  return useMutation<any, ApiError, { otp: string }, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post({
        url: 'api/v1/auth/accounts/mfa/verify-otp',
        payload,
      });

      return data;
    },
    onSuccess: (successData, { remember }: any) => {
      toastSuccess('Successfully verified otp');

      setProfile({ profile: successData.data, remember });
    },
  });
}

export default useLoginNominateVerifyOtp;
